import { defineMessages } from 'react-intl-next';

export default defineMessages({
	closeButtonLabel: {
		id: 'ai-mate.inline-chat-input.error-view.close-button.label',
		defaultMessage: 'Close',
		description: 'Label for the close button in the error state of a status indicator',
	},
	retryButtonLabel: {
		id: 'ai-mate.inline-chat-input.error-view.retry-button.label',
		defaultMessage: 'Try again',
		description: 'Label for the retry button in the error state of a status indicator',
	},
	rateLimited: {
		id: 'ai-mate.inline-chat-input.error-view.message.rate-limited',
		defaultMessage:
			'You’ve reached the maximum number of requests. Try again later. <a>Excessive use of AI</a>.',
		description:
			'Error message displayed when the user exceeds the rate limit for requests. Text in <a></a> tags will link to documentation',
	},
	aupViolation: {
		id: 'ai-mate.inline-chat-input.error-view.message.aup-violation',
		defaultMessage: 'Content does not comply with our <a>Acceptable Use Policy</a>.',
		description:
			'Error message displayed when the user violates the Acceptable Use Policy. Text in <a></a> tags will link to documentation',
	},
	tokenLimitExceeded: {
		id: 'ai-mate.inline-chat-input.error-view.message.token-limit-exceeded',
		defaultMessage: 'There’s too much content to process. Select less content and try again.',
		description:
			'Error message displayed when the user exceeds the amount they are allowed to select when making a request to the AI',
	},
	unknownError: {
		id: 'ai-mate.inline-chat-input.error-view.message.unknown-error',
		defaultMessage: 'An unknown error occurred.',
		description: 'Error message displayed when an unknown Rovo error occurs.',
	},
});
